import { render, staticRenderFns } from "./FiveStar.vue?vue&type=template&id=53f9b08b&"
import script from "./FiveStar.vue?vue&type=script&lang=js&"
export * from "./FiveStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FiveStar.vue"
export default component.exports